export function formatDateInputLocal(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getTomorrowDateInputValue(baseDate = new Date()) {
  const tomorrow = new Date(baseDate);
  tomorrow.setHours(0, 0, 0, 0);
  tomorrow.setDate(tomorrow.getDate() + 1);
  return formatDateInputLocal(tomorrow);
}

export function isDateInputTomorrowOrLater(value, baseDate = new Date()) {
  if (!value) return false;
  return value >= getTomorrowDateInputValue(baseDate);
}
